import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface UserInfo {
  merchantId: string;
  merchantLabel: string;
  cnpj: string;
  clientId: string;
}

@Injectable({
  providedIn: 'root',
})
export class TefBoxService {
  constructor(private http: HttpClient) {}

  //#region Merchant
  getMerchant() {}
  //#endregion

  //#region Transactions
  getTransactions(filtro: any) {
    let params = new HttpParams();

    Object.entries(filtro).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        // Se for array, adiciona todos os itens como múltiplos parâmetros
        if (Array.isArray(value)) {
          value.forEach((val) => {
            params = params.append(key, val);
          });
        } else {
          params = params.set(key, value.toString());
        }
      }
    });

    return this.http.get<any>('transaction', {
      params,
    });
  }
  //#endregion

  //#region Checkout
  getCheckouts() {
    return this.http.get<any[]>('lojista/checkout');
  }

  registerCheckout(checkoutLabel: string) {
    return this.http.post(`lojista/checkout?checkoutLabel=${checkoutLabel}`, null);
  }

  deletarCheckout(checkoutId: string) {
    return this.http.delete(`lojista/checkout/${checkoutId}`);
  }
  //#endregion

  //#region Dashboard
  getResumoGanhos(dateRange: number[]) {
    return this.http.get<number[]>(`transaction/resumo/${dateRange[0]}-${dateRange[1]}`);
  }

  getAverage(dateRange: number[]) {
    return this.http.get<any>(`transaction/average/${dateRange[0]}-${dateRange[1]}`);
  }
  //#endregion

  //#region User
  getUserInfo() {
    return this.http.get<UserInfo>('lojista/user');
  }
  //#endregion

  //#region Terminal
  getTerminals(checkoutId: string) {
    return this.http.get<any>(`lojista/terminal?checkoutId=${checkoutId}`);
  }

  clearTerminalStatus(linker: string) {
    return this.http.get<any>(`lojista/terminal/clear?linker=${linker}`);
  }
  //#endregion
}
